export const InitialZoomValue = 100
export const ZoomInterval = 25
export const MaxZoomValue = 500
export const MinZoomValue = 50
export const ScalesArray = [50, 75, 100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500]
